const schema = () => ({
  type: "object",
  required: [],
  properties: {
    // doctor_ids: {
    //   type: "array",
    //   title: "پزشک ها",
    //   items: []
    // },
    unit_ids: {
      type: "array",
      title: "کلینیک ها",
      items: {
        type: "string",
      },
    },
    lab_ids: {
      type: "array",
      title: "لابراتوار ها",
      items: {
        type: "string",
      },
    },
  },
});

export default schema;
